import { forwardRef } from 'react';
import { cn } from '../../lib/cn';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  hint?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, hint, className, id, ...props }, ref) => {
    const inputId = id ?? label?.toLowerCase().replace(/\s+/g, '-');

    return (
      <div className="flex flex-col gap-1.5">
        {label ? (
          <label htmlFor={inputId} className="text-xs text-[hsl(var(--color-muted))]">
            {label}
          </label>
        ) : null}
        <input
          ref={ref}
          id={inputId}
          className={cn(
            'w-full rounded-[var(--radius)] border border-[hsl(var(--color-hairline))] bg-[hsl(var(--color-bone))] px-2 py-1 text-xs text-[hsl(var(--color-ink))]',
            'placeholder:text-[hsl(var(--color-text-placeholder))]',
            'focus:outline-none focus:ring-1 focus:ring-[hsl(var(--color-ochre))]',
            'disabled:cursor-not-allowed disabled:opacity-50',
            error && 'border-[hsl(var(--color-oxblood))] focus:ring-[hsl(var(--color-oxblood))]',
            className,
          )}
          {...props}
        />
        {error ? <p className="text-xs text-[hsl(var(--color-oxblood))]">{error}</p> : null}
        {hint && !error ? <p className="text-xs text-[hsl(var(--color-muted))]">{hint}</p> : null}
      </div>
    );
  },
);
Input.displayName = 'Input';
